import React, { useMemo } from 'react';
import { Input, FormFeedback } from 'reactstrap';
import { positionEnum } from 'consts/data';
import { encodeTrueFalse } from 'helpers';
import { isBoolean } from 'lodash';
import { cn } from 'helpers/css';
import { Circle } from 'lucide-react';

const RadioField = ({
  form,
  field,
  label,
  disabled,
  onChangeCustomize,
  afterOnChange,
  enableDefaultOnChange = false,
  style,
  valueRadio,
  id,
  positionLabel = positionEnum.left,
  checked = undefined,
  classNameContainer,
}) => {
  const { name, value } = field || {};
  const { errors = {}, touched = {}, setFieldValue } = form || {};

  const isChecked = useMemo(() => {
    if (isBoolean(checked)) {
      return checked;
    }

    if (['true', 'false'].includes(encodeTrueFalse(valueRadio)) && value !== undefined) {
      return valueRadio.toString() === value.toString();
    }

    return value == valueRadio;
  }, [valueRadio, value, checked]);

  const handleChange = (e) => {
    if (disabled) {
      return;
    }

    if (onChangeCustomize) {
      onChangeCustomize(valueRadio);
      if (enableDefaultOnChange) {
        setFieldValue(name, valueRadio);
      }

      return;
    }

    setFieldValue(name, valueRadio);
    afterOnChange && afterOnChange(valueRadio);
  };

  const renderLabel = () => {
    return (
      <label className='tw-mb-0' htmlFor={`${name}-${id}`}>
        {label}
      </label>
    );
  };

  return (
    <div className={cn('component:RadioField', classNameContainer)}>
      <div className='tw-flex tw-gap-2 tw-items-center'>
        {positionLabel === positionEnum.left && renderLabel()}
        <Input
          {...field}
          type='radio'
          style={style}
          onChange={handleChange}
          className={'tw-hidden'}
          id={`${name}-${id}`}
          value={valueRadio}
          checked={isChecked}
          disabled={disabled}
          invalid={!!errors[name] && touched[name]}
        />
        <span
          onClick={handleChange}
          className={cn(
            'tw-aspect-square tw-h-4 tw-w-4 tw-rounded-full tw-border tw-border-primary tw-text-primary tw-shadow focus:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring tw-cursor-pointer',
            disabled && 'tw-cursor-not-allowed tw-opacity-50'
          )}
        >
          {isChecked && (
            <div className='tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center'>
              <Circle className='tw-h-2.5 tw-w-2.5 tw-fill-primary' />
            </div>
          )}
        </span>
        {positionLabel === positionEnum.right && renderLabel()}
      </div>

      {touched[name] && errors[name] && <FormFeedback>{errors[name]}</FormFeedback>}
    </div>
  );
};

export default RadioField;
